/**
 * Botón "💡 Tips de Bookvia" contextual por pestaña.
 * Abre un modal con tips prácticos específicos de la sección.
 */
import { useState } from 'react';
import { Lightbulb, X } from 'lucide-react';

export default function BookviaTipsButton({ tabKey, tipsData }) {
  const [open, setOpen] = useState(false);
  const content = tipsData?.[tabKey];
  if (!content) return null;

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="inline-flex items-center gap-1.5 rounded-full border border-[#fbdcd6] bg-[#fff5f2] px-3 py-1.5 text-xs font-medium text-[#F05D5E] transition-all hover:border-[#F05D5E] hover:bg-[#fce8e5] focus:outline-none focus:ring-2 focus:ring-[#F05D5E]/30"
        data-testid={`bookvia-tips-btn-${tabKey}`}
      >
        <Lightbulb className="h-3.5 w-3.5" />
        Tips de Bookvia
      </button>

      {open ? (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4 backdrop-blur-sm"
          onClick={() => setOpen(false)}
        >
          <div
            className="w-full max-w-lg overflow-hidden rounded-2xl bg-white shadow-2xl"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
          >
            <div className="bg-gradient-to-br from-[#F05D5E] to-[#d64431] px-6 py-5 text-white">
              <div className="flex items-start justify-between gap-4">
                <div>
                  <p className="mb-1 text-xs font-semibold uppercase tracking-wider text-white/80">
                    Tip de Bookvia · {content.label}
                  </p>
                  <h3 className="text-xl font-bold">{content.headline}</h3>
                </div>
                <button
                  type="button"
                  onClick={() => setOpen(false)}
                  className="rounded-full p-1 transition-colors hover:bg-white/20"
                  aria-label="Cerrar"
                  data-testid="bookvia-tips-close"
                >
                  <X className="h-5 w-5" />
                </button>
              </div>
            </div>

            <div className="max-h-[60vh] overflow-y-auto px-6 py-5">
              <div className="space-y-4">
                {content.tips.map((tip, idx) => (
                  <div key={idx} className="flex gap-3">
                    <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg bg-[#fff5f2] text-lg">
                      {tip.icon}
                    </div>
                    <div className="flex-1">
                      <p className="text-sm font-semibold text-neutral-900">{tip.title}</p>
                      <p className="mt-0.5 text-sm text-neutral-600">{tip.body}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="border-t border-neutral-100 bg-neutral-50 px-6 py-4 text-center">
              <button
                type="button"
                onClick={() => setOpen(false)}
                className="text-sm font-medium text-neutral-600 hover:text-neutral-900"
                data-testid="bookvia-tips-apply"
              >
                Cerrar y aplicar tips
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}
